import React from "react"
import {
  TextField,
  TextFieldProps,
  OutlinedInputProps,
  styled,
} from "@mui/material"

import { colors } from "theme"

type Props = TextFieldProps & { light?: boolean }

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const InputComponent = styled(({ light, ...restProps }: Props) => (
  <TextField
    variant="filled"
    InputProps={{ disableUnderline: true } as Partial<OutlinedInputProps>}
    {...restProps}
  />
))(({ light = false }) => ({
  "& .MuiFilledInput-root": {
    border: "none",
    overflow: "hidden",
    borderRadius: 9,
    backgroundColor: light ? colors.white : colors.ghostWhite,
    "&:hover": {
      backgroundColor: light ? colors.white : colors.ghostWhite,
    },
    "&.Mui-disabled": {
      backgroundColor: light ? colors.white : colors.ghostWhite,
    },
    "&.Mui-focused": {
      backgroundColor: light ? colors.white : colors.ghostWhite,
    },
  },
  "& .MuiInputLabel-root": {
    color: colors.romanSilver,
    "&:hover": {
      color: colors.romanSilver,
    },
    "&.Mui-focused": {
      color: colors.romanSilver,
    },
  },
  "& .MuiFormHelperText-root": {
    color: colors.ruby,
    letterSpacing: "0.6px",
  },
}))

InputComponent.defaultProps = {
  light: false,
}

export default InputComponent
